export const shouldSubscribeSalonMailchimp = (currentUser) => {
  const salon = currentUser && currentUser.salon;
  return Boolean(
    salon &&
      salon.id &&
      salon.mailchimp_subscription_required === true &&
      !salon.mailchimp_subscribe_id
  );
};
